// src/utils/urlUtils.js

// Mapping between Arabic department names and English URL paths
export const DEPARTMENT_MAPPINGS = {
  // Arabic to English
  'الرجال': 'men',
  'النساء': 'women', 
  'الأطفال': 'children',
  
  // English to Arabic (reverse mapping)
  'men': 'الرجال',
  'women': 'النساء',
  'children': 'الأطفال'
};

/**
 * Convert Arabic department name to English URL path
 * @param {string} arabicName - Arabic department name
 * @returns {string} English URL path
 */
export const getEnglishPath = (arabicName) => {
  return DEPARTMENT_MAPPINGS[arabicName] || 'men';
};

/**
 * Convert English URL path to Arabic department name
 * @param {string} englishPath - English URL path
 * @returns {string} Arabic department name
 */
export const getArabicName = (englishPath) => {
  return DEPARTMENT_MAPPINGS[englishPath] || 'الرجال';
};

/**
 * Get full department URL path from Arabic name
 * @param {string} arabicName - Arabic department name
 * @returns {string} Full URL path
 */
export const getDepartmentPath = (arabicName) => {
  const englishPath = getEnglishPath(arabicName);
  return `/department/${englishPath}`;
};

/**
 * Extract department from current URL path
 * @param {string} pathname - Current URL pathname
 * @returns {string} Arabic department name
 */
export const getDepartmentFromPath = (pathname) => {
  if (pathname.includes('/department/men')) return 'الرجال';
  if (pathname.includes('/department/women')) return 'النساء';
  if (pathname.includes('/department/children')) return 'الأطفال';
  return 'الرجال'; // default
};

/**
 * Build category URL within a department
 * @param {string} departmentPath - Department path (e.g., '/department/men')
 * @param {string} categoryName - Arabic category name
 * @returns {string} Complete category URL
 */
export const getCategoryPath = (departmentPath, categoryName) => {
  return `${departmentPath}/${encodeURIComponent(categoryName)}`;
};

/**
 * Build URL with search parameters
 * @param {string} basePath - Base URL path
 * @param {URLSearchParams} searchParams - Search parameters
 * @returns {string} Complete URL with parameters
 */
export const buildUrlWithParams = (basePath, searchParams) => {
  const params = searchParams.toString();
  return params ? `${basePath}?${params}` : basePath;
};